import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import Loading, { LoadingBall } from '@ingka/loading';
import '@ingka/loading/dist/style.css';
import { useTranslation } from 'react-i18next';
import style from './loading.module.scss';

function ArcLoading(props) {
  const {
    width, height, message,
    isShow,
    type,
  } = props;
  const { t } = useTranslation();
  // eslint-disable-next-line react/no-this-in-sfc
  window.t = t;
  // 在局部loading时，显示全局的遮罩
  const isShowInitMask = () => {
    if (type === 'localScreen') {
      return (
        <div className={`${style.initFullMask}`} />
      );
    }
    return null;
  };
  return (
    isShow
      ? (
        <>
          {isShowInitMask()}
          <div style={{ width, height }} className={`${style.fullMask} ${type === 'localScreen' && style.mask}`}>
            <div role="presentation" className={style.content}>
              {/* <div className={style.ball} />
              <p>{message}</p> */}
              <Loading className="some-prefix-loading--custom-class" text="" labelTransitions>
                <LoadingBall size="large" />
              </Loading>
              <p>{message}</p>
            </div>
          </div>
        </>
      )
      : null
  );
}

ArcLoading.show = function show(options = {
  width: '100%',
  height: '100%',
  message: window.t('other.loading'),
  type: 'fullScreen',
}) {
  if (document.getElementById('arcLoading')) {
    return;
  }
  const {
    width, height, message, type,
  } = options;
  const dom = document.createElement('div');
  dom.setAttribute('id', 'arcLoading');
  document.body.appendChild(dom);
  ReactDOM.render(<ArcLoading width={width} height={height} message={message} isShow type={type} />, dom);
};


ArcLoading.hide = function hide() {
  if (document.getElementById('arcLoading')) {
    ReactDOM.unmountComponentAtNode(document.getElementById('arcLoading'));
    document.getElementById('arcLoading').parentNode.removeChild(document.getElementById('arcLoading'));
  }
};

ArcLoading.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  message: PropTypes.string.isRequired,
  isShow: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
};

ArcLoading.defaultProps = {
};

export default ArcLoading;
